import { Link } from 'react-router-dom';

interface Madera {
  id: number;
  nombre: string;
  slug: string;
  imagen: string;
  categoria: string;
  descripcion?: string;
}

const maderas: Madera[] = [
  {
    id: 1,
    nombre: 'Roble',
    slug: 'roble',
    imagen: '/images/maderas_naturales/roble.webp',
    categoria: 'roble',
    descripcion: 'El Roble es una madera versátil que da lugar a distintos acabados. En este caso hablamos de la variante de roble sin nudos.'
  },
  {
    id: 2,
    nombre: 'Roble Vintage',
    slug: 'roble-vintage',
    imagen: '/images/maderas_naturales/roble_vintage.webp',
    categoria: 'roble',
    descripcion: 'Roble Vintage: tablero compuesto por chapa seleccionada del interior del tronco del roble. Las grietas naturales y nudos abiertos resaltan su carácter.'
  },
  {
    id: 3,
    nombre: 'Nogal',
    slug: 'nogal',
    imagen: '/images/maderas_naturales/nogal.webp',
    categoria: 'nogal',
    descripcion: 'La preciosa madera de Nogal es un clásico en nuestra gama. Optamos por acabados naturales para preservar su personalidad y elegancia.'
  },
  {
    id: 4,
    nombre: 'Mongoy (Ovangkol)',
    slug: 'mongoy-ovangkol',
    imagen: '/images/maderas_naturales/mongoy.webp',
    categoria: 'tropical',
    descripcion: 'La madera de Mongoy, también conocida como Ovangkol, destaca por su estética versátil y combinaciones de tonalidades en sus vetas.'
  },
  {
    id: 5,
    nombre: 'Etimoe',
    slug: 'etimoe',
    imagen: '/images/maderas_naturales/etimoe.webp',
    categoria: 'tropical',
    descripcion: 'La madera de Etimoe, de procedencia tropical, posee unas vetas distintivas que van desde un marrón oscuro hasta tonalidades rojizas. Una madera elegante que aporta toques exóticos y exclusivos a tu baño.'
  },
  {
    id: 6,
    nombre: 'Ébano',
    slug: 'ebano',
    imagen: '/images/maderas_naturales/ebano.webp',
    categoria: 'tropical',
    descripcion: 'La madera de Ébano destaca por la tonalidad de su madera, que entrelaza vetas negras con vetas de tonalidad marrón oscura. Ideal para ambientes exóticos y exclusivos.'
  },
  {
    id: 7,
    nombre: 'Zebrano',
    slug: 'zebrano',
    imagen: '/images/maderas_naturales/zebrano.webp',
    categoria: 'tropical',
    descripcion: 'La madera Zebrano es de origen tropical. Sus vetas tienen una transición más suave, desde tonalidades marrón claro casi amarillentas hasta líneas diferenciadas de marrón marcado.'
  },
];

export default function MaderasSection() {
  return (
    <>
      {/* Maderas Section */}
      <div className="bg-white rounded-lg overflow-hidden">
        {/* Section Header */}
        <div className="relative">
          <div
            className="bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center"
            style={{ aspectRatio: 'auto' }}
          >
            <picture className="w-full h-full">
              <source media="(max-width: 768px)" srcSet="/images/proyectos/p26.jpeg" />
              <img
                src="/images/maderas_naturales/maderasection_hero02.webp"
                alt="Muebles de baño con maderas naturales - Acabados premium"
                className="w-full h-full object-contain md:object-cover opacity-80"
              />
            </picture>
            <div className="absolute inset-0 bg-[#191a19] bg-opacity-40 flex items-center justify-center px-4">
              <div className="text-center text-white max-w-4xl w-full">
                <h2
                  className="font-light leading-tight"
                  style={{
                    fontFamily: 'Playfair Display, serif',
                    fontSize: 'clamp(1.5rem, 5vw, 5rem)',
                    marginBottom: 'clamp(0.5rem, 2vh, 2rem)'
                  }}
                >
                  MADERAS NATURALES
                </h2>
                <p
                  className="opacity-90 leading-snug"
                  style={{
                    fontFamily: 'Cormorant Garamond, serif',
                    fontSize: 'clamp(0.875rem, 2.5vw, 1.25rem)',
                    marginBottom: 'clamp(0.25rem, 1vh, 0.75rem)'
                  }}
                >
                  Roble, Roble vintage, Nogal, Mongoy, Etimoe, Ébano y Zebrano
                </p>
                <p
                  className="opacity-75 leading-snug px-2"
                  style={{
                    fontFamily: 'Cormorant Garamond, serif',
                    fontSize: 'clamp(0.75rem, 2vw, 1rem)',
                    lineHeight: 1.4
                  }}
                >
                  Fabricado sobre tablero marino hidrófugo. Laminas exteriores compuestas por la madera natural escogida. Núcleo compuesto por láminas de madera de abedul macizas
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Maderas Grid */}
        <div style={{ padding: 'clamp(1rem, 2vw, 3rem)' }}>
          <div className="border-b border-gray-200" style={{ padding: 'clamp(1rem, 1.5vw, 2rem) 0' }}>
            <div className="flex items-center space-x-2 text-gray-700">
              <span
                className="font-medium"
                style={{
                  fontFamily: 'Playfair Display, serif',
                  fontSize: 'clamp(1rem, 1.5vw, 1.5rem)'
                }}
              >
                Maderas disponibles
              </span>
            </div>
          </div>

          <div
            className="grid gap-6"
            style={{
              gridTemplateColumns: 'repeat(auto-fit, minmax(clamp(120px, 15vw, 200px), 1fr))',
              gap: 'clamp(1rem, 2vw, 2rem)',
              padding: 'clamp(1rem, 2vh, 3rem) 0'
            }}
          >
            {maderas.map((madera) => (
              <Link key={madera.id} to={`/maderas/${madera.slug}`} className="group block">
                <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden">
                  <img src={madera.imagen} alt={madera.nombre} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                </div>
                <div className="text-center mt-2">
                  <h3 
                    className="font-medium text-gray-900"
                    style={{
                      fontFamily: 'Cormorant Garamond, serif',
                      fontSize: 'clamp(0.875rem, 1.2vw, 1.1rem)'
                    }}
                  >
                    {madera.nombre}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}